import { Modal } from "antd";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CheckIcon } from "../../SvgComponents/CheckIcon/CheckIcon";
import { CancelIcon } from "../../SvgComponents/CancelIcon/CancelIcon";

export const ResendConfirmationModal = ({ openModalResendConfirmation, setOpenModalResendConfirmation, handleResendOTP, phoneNumber }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Modal
            title={t('wizard.verification')}
            footer={null}
            open={openModalResendConfirmation}
            closable={true}
            onCancel={() => setOpenModalResendConfirmation(false)}
        >
            <div className="modal-container">
                <p className="nu-input-label">{t('wizard.is_number_correct', { number: phoneNumber })} <br />
                {t('wizard.update_details')}</p>
                <Row className="action-buttons mobile-button">
                    <Col md={6} xs={6}>
                        <button type="button" className="btn btn-secondary btn-cancel" onClick={() => {
                            setOpenModalResendConfirmation(false);
                            navigate('/otp-resend-rejected');
                        }}>
                            <span className="cancel-text">{t('general.no')}</span>
                            <CancelIcon />
                        </button>
                    </Col>
                    <Col md={6} xs={6}>
                        <button type="button" className="btn btn-primary btn-active" onClick={handleResendOTP}>
                            <span className="cancel-text">{t('general.yes')}</span>
                            <CheckIcon />
                        </button>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};